import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isSupabaseConfigured, supabase } from '@/lib/supabase';

const ADMIN_EMAIL = 'admin@donnos.com.br';
const ADMIN_PASSWORD = 'Donnos1234!';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (isSupabaseConfigured && supabase) {
      const { error: signInError } = await supabase.auth.signInWithPassword({ email, password });
      if (!signInError) {
        localStorage.setItem('donnos_admin_auth', 'true');
        navigate('/admin');
        return;
      }
    }

    window.setTimeout(() => {
      if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
        localStorage.setItem('donnos_admin_auth', 'true');
        navigate('/admin');
      } else {
        setError('E-mail ou senha incorretos.');
        setLoading(false);
      }
    }, 800);
  };

  return (
    <div className="min-h-screen flex">
      {/* Left - Background Image */}
      <div className="hidden lg:flex lg:w-1/2 relative">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20dark%20technology%20corporate%20office%20interior%20with%20glowing%20green%20LED%20accent%20lights%2C%20server%20room%20%20corridor%20with%20glass%20walls%2C%20futuristic%20tech%20atmosphere%2C%20deep%20blue%20and%20green%20color%20scheme%2C%20professional%20business%20environment%2C%20cinematic%20lighting%2C%20high%20contrast&width=900&height=1080&seq=donnos-login-bg&orientation=portrait"
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-donnos-dark/60" />
        <div className="relative z-10 flex flex-col justify-end p-12">
          <div className="w-12 h-12 rounded-lg bg-donnos-green flex items-center justify-center mb-6">
            <i className="ri-settings-4-line text-white text-2xl"></i>
          </div>
          <h2 className="text-3xl font-bold text-white mb-3 leading-tight">
            Painel Administrativo
          </h2>
          <p className="text-gray-300 text-base leading-relaxed max-w-md">
            Gerencie atas de registro de preços, produtos e acompanhe métricas em tempo real. Acesso exclusivo para administradores.
          </p>
        </div>
      </div>

      {/* Right - Login Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center bg-white p-8">
        <div className="w-full max-w-md">
          {/* Logo */}
          <div className="text-center mb-10">
            <div className="mb-4 inline-flex h-28 items-center justify-center">
              <img
                src="/assets/donnos-logo-login.png"
                alt="Donnos - Vendas e Serviços Integrados"
                className="h-full w-auto object-contain"
              />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mt-6">Bem-vindo de volta</h2>
            <p className="text-sm text-gray-500 mt-2">Entre com suas credenciais para acessar o painel</p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div className="flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-100 rounded-lg text-sm text-red-600">
                <i className="ri-error-warning-line flex-shrink-0"></i>
                {error}
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">E-mail</label>
              <div className="relative">
                <i className="ri-mail-line absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"></i>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="seu@email.com"
                  className="w-full pl-11 pr-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:border-donnos-green focus:ring-1 focus:ring-donnos-green transition-colors"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Senha</label>
              <div className="relative">
                <i className="ri-lock-line absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"></i>
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full pl-11 pr-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:border-donnos-green focus:ring-1 focus:ring-donnos-green transition-colors"
                />
              </div>
            </div>

            <div className="flex items-center justify-between">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" className="w-4 h-4 rounded border-gray-300 text-donnos-green focus:ring-donnos-green" />
                <span className="text-sm text-gray-600">Lembrar-me</span>
              </label>
              <a href="#" className="text-sm font-medium text-donnos-green hover:text-donnos-green-dark transition-colors">
                Esqueceu a senha?
              </a>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-donnos-green hover:bg-donnos-green-dark text-white font-semibold py-3 rounded-lg transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {loading ? (
                <>
                  <i className="ri-loader-4-line animate-spin"></i>
                  Entrando...
                </>
              ) : (
                <>
                  <i className="ri-login-box-line"></i>
                  Entrar no painel
                </>
              )}
            </button>
          </form>

          {/* Back to site */}
          <div className="mt-6 text-center">
            <a href="/" className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-donnos-green transition-colors">
              <i className="ri-arrow-left-line"></i>
              Voltar para o site
            </a>
            <p className="mt-6 text-xs font-medium text-gray-400">
              Orgulhosamente desenvolvido pro Serra Consultoria
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
